export default __webpack_public_path__ + "static/media/Thaumaturge's Helm of Imperial Assent.fbffd101.jpg";